import {
    ResponsiveContainer,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    BarChart,
    Bar,
} from "recharts";

const CategoryRevenueChart = ({ data, loading }) => {

    if (loading) {
        return (
            <div className="h-[350px] flex items-center justify-center">
                Loading...
            </div>
        );
    }

    if (!data.length) {
        return (
            <div className="h-[350px] flex items-center justify-center text-muted-foreground">
                No records available for the current month.
            </div>
        );
    }

    return (

        <ResponsiveContainer
            width="100%"
            height={350}
        >

            <BarChart
                data={data}
            >

                <CartesianGrid strokeDasharray="3 3" />

                <XAxis
                    dataKey="categoryName"
                />

                <YAxis />

                <Tooltip
                    formatter={(value) =>
                        `₹${Number(value).toLocaleString()}`
                    }
                />

                <Bar
                    dataKey="totalEarning"
                    fill="#2563EB"
                    radius={[6, 6, 0, 0]}
                    minPointSize={4}

                />

            </BarChart>

        </ResponsiveContainer>

    );

};

export default CategoryRevenueChart;